export default async (blob: Blob): Promise<string> => await new Promise(resolve => {
  const fr = new FileReader()
  fr.onload = data => resolve((data.target?.result as string).split(';base64,')[1])
  fr.readAsDataURL(blob)
})
